export default __webpack_public_path__ + "static/media/logo_sowin.dac5b72d.svg";